import { createStore } from 'vuex'

// Create a new store instance.
const store = createStore({
    state() {
        return {
            isAuthenticated: false,
            dashboardLoaded: false
        };
    },
    mutations: {
        login(state) {
            state.isAuthenticated = true;
        },
        logout(state) {
            state.isAuthenticated = false;
            state.dashboardLoaded = false;
            localStorage.removeItem('10-4-Token');
            localStorage.removeItem('10-4-AvatarURL');
            localStorage.removeItem('10-4-Username');
        },
        setDashboardLoaded(state) {
            state.dashboardLoaded = true;
        }
    },
    actions: {
        login({ commit }) {
            commit('login');
        },
        logout({ commit }) {
            commit('logout');
        },
        setDashboardLoaded({ commit }) {
            commit('setDashboardLoaded');
        }
    }
})

export default store